import { render, staticRenderFns } from "./NoticeBarPreview.vue?vue&type=template&id=adc356aa&scoped=true&"
import script from "./NoticeBarPreview.vue?vue&type=script&lang=js&"
export * from "./NoticeBarPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc356aa",
  null
  
)

export default component.exports